import { useTranslation } from 'react-i18next';
import { SubscriptionStatusBadge } from 'src/common/components/ConfigurableTable/Components/Badges/SubscriptionStatusBadge';
import {
  getLabelBaseOnSubscriptionStatus,
  SubscriptionStatus,
} from 'src/common/components/SubscriptionStatus/constants/subscriptionStatus';
import { TableTooltip } from 'src/common/components/Tooltip/TableTooltip';
import { CellLayout, CellLayoutRow } from './CellLayout';
import Box from '@mui/material/Box';

export type SubscriptionStatusCellProps = {
  subscriptionStatus: SubscriptionStatus;
};

export const SubscriptionStatusCell = ({ subscriptionStatus }: SubscriptionStatusCellProps) => {
  const { t } = useTranslation();
  return (
    <CellLayout>
      <CellLayoutRow>
        <Box
          data-testid="primaryText"
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            ml: -8,
            mr: -8,
          }}
        >
          <TableTooltip value={getLabelBaseOnSubscriptionStatus(subscriptionStatus, t)}>
            <SubscriptionStatusBadge subscriptionStatus={subscriptionStatus} />
          </TableTooltip>
        </Box>
      </CellLayoutRow>
    </CellLayout>
  );
};
